
// function cpProductSlider(){
// const sliders = document.querySelectorAll("[data-slider]");

// sliders.forEach((slider) => {
//   const sliderInner = slider.querySelector(".cp-product-slider-inner");

//   if (sliderInner && sliderInner.children.length > 1) {
//     const config = JSON.parse(sliderInner.getAttribute("data-config"));
//     const flickityInstance = new Flickity(sliderInner, config);
//     const imgs = sliderInner.querySelectorAll("img");

//     imgs.forEach((img) => {
//       img.addEventListener("load", () => {
//         flickityInstance.resize();
//       });
//     });

//     if (typeof modelView !== "undefined" && modelView) {
//       flickityInstance.select(1);
//     } else {
//       flickityInstance.select(0);
//     }
//     const dots = sliderInner.querySelector(".flickity-page-dots");
//     let hideTimeout;

//     function showDotsTemporarily() {
//       if (!dots) return;
//       dots.style.opacity = "1"; 
//       clearTimeout(hideTimeout);
//       hideTimeout = setTimeout(() => {
//         dots.style.opacity = "0"; 
//       }, 1000);
//     }

//     flickityInstance.on("change", () => {
//       showDotsTemporarily();
//     });
//   }
// });

// }

// document.addEventListener("DOMContentLoaded", cpProductSlider);


function cpProductSlider() {
  const sliders = document.querySelectorAll("[data-slider]");

  sliders.forEach((slider) => {
    const sliderInner = slider.querySelector(".cp-product-slider-inner");
    if (!sliderInner) return;

    const imgs = Array.from(sliderInner.querySelectorAll("img"));
    if (imgs.length <= 1) return;

    const config = JSON.parse(sliderInner.getAttribute("data-config"));
    
    // Wait for all images to load before initializing
    let loadedCount = 0;
    imgs.forEach((img) => {
      if (img.complete) loadedCount++;
      else img.addEventListener("load", () => {
        loadedCount++;
        if (loadedCount === imgs.length) initFlickity();
      });
    });

    if (loadedCount === imgs.length) initFlickity(); // all already loaded

    function initFlickity() {
      const flickityInstance = new Flickity(sliderInner, config);
      imgs.forEach((img) => {
        img.addEventListener("load", () => flickityInstance.resize());
      });

      if (typeof modelView !== "undefined" && modelView) {
        flickityInstance.select(1);
      } else {
        flickityInstance.select(0);
      }

      const dots = sliderInner.querySelector(".flickity-page-dots");
      let hideTimeout;

      function showDotsTemporarily() {
        if (!dots) return;
        dots.style.opacity = "1";
        clearTimeout(hideTimeout);
        hideTimeout = setTimeout(() => (dots.style.opacity = "0"), 1000);
      }

      flickityInstance.on("change", showDotsTemporarily);
    }
  });
}

document.addEventListener("DOMContentLoaded", cpProductSlider);
